import React from 'react';

import HeroImage from './HeroImage';

const Header = () => (
  <div className="m-auto mb-[107px] flex w-full max-w-container-lg justify-center sm:mb-112 sm:justify-between md:mb-0">
    <div className="max-w-[385px] text-center font-suisse-neue sm:max-w-[500px] sm:text-left md:max-w-[390px] lg:max-w-[500px]">
      <h1 className="my-0 mb-8 mt-0 text-headline-md sm:text-headline-lg">About Us</h1>
      <div className="text-body-md sm:text-body-lg ">
        The Information is where you go to get the most important news about technology and business
        first.
      </div>
    </div>
    <div className="hidden md:block">
      <HeroImage heroImageWrapperClassName="m-0" signatureWrapperClassName="ml-0" />
    </div>
  </div>
);

export default Header;
